<template>
  <v-card :loading="loading" v-bind="$attrs" v-on="$listeners">
    <v-card-title>
      <v-row>
        <v-col>
          <span class="headline">Racer Support</span>
        </v-col>
        <v-col class="text-right">
          <v-btn small color="primary" :disabled="!items.length || loading" :to="{ name: 'racerSupports' }">
            View All
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-subtitle>Current Payouts</v-card-subtitle>
    <v-card-text class="display-2 text-center">
      <v-progress-circular v-if="loading" :size="20" indeterminate color="primary"></v-progress-circular>
      <v-data-table v-else-if="items.length" :items="items" :headers="headers" hide-default-footer>
        <template v-slot:item.modelCode="{ item }">
          {{ item.productKey || "N/A" }}
        </template>
        <template v-slot:item.payoutAmount="{ item }">
          {{ item.payoutAmount || 0 | toCurrency }}
        </template>
      </v-data-table>
      <v-alert v-else type="info">No Payouts.</v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "RacerSupportWidget",
  data() {
    return {
      items: [],
      headers: [
        { value: "serialNumber", text: "VIN Number", sortable: false },
        { value: "modelCode", text: "Model Code", sortable: false },
        { value: "payoutAmount", text: "Amount", sortable: false }
      ],
      options: {
        itemsPerPage: 1000,
        page: 1,
        sortBy: ["updatedDate"],
        sortDesc: [true]
      },
      selectedAwardVehicle: null,
      loading: true
    };
  },
  methods: {
    async fetchData() {
      this.selectedAwardVehicle = null;

      if (!this.selectedParticipant?.id) {
        this.items = [];
        this.loading = false;
        return;
      }

      this.loading = true;

      try {
        const availableAwardVehicles = await this.$awardvehicle.getAvailableAwardVehicles(this.selectedParticipant);
        this.selectedAwardVehicle = availableAwardVehicles.find(av => av?.awardVehicleKey === "RACER_PAYOUTS");

        if (!this.selectedAwardVehicle?.id) {
          this.items = [];
          return;
        }

        const params = this.$util.buildPaginationParams(this.options);
        params.append("expand", "saleProduct.product");

        let filters = {
          participant: { id: this.selectedParticipant.id },
          awardVehicle: { id: this.selectedAwardVehicle.id },
          hasSale: true,
          isEffective: true
        };

        let payouts = await this.$api.post(`/api/payouts/search?${params.toString()}`, filters);

        this.items = this.groupPayoutsByVin(payouts.data.content).slice(0, 3);
      } catch {
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    groupPayoutsByVin(payouts) {
      const grouped = payouts.reduce((groups, payout) => {
        const serialNumber = payout.saleProduct?.serialNumber || "N/A";

        if (!groups[serialNumber]) {
          groups[serialNumber] = {
            serialNumber,
            productKey: payout.saleProduct?.product?.productKey,
            payoutAmount: 0,
            updatedDate: payout.updatedDate
          };
        }

        groups[serialNumber].payoutAmount += payout.payoutAmount || 0;

        if (
          payout.updatedDate &&
          (!groups[serialNumber].updatedDate || payout.updatedDate > groups[serialNumber].updatedDate)
        ) {
          groups[serialNumber].updatedDate = payout.updatedDate;
          groups[serialNumber].productKey = payout.saleProduct?.product?.productKey;
        }

        return groups;
      }, {});

      return Object.values(grouped).sort((a, b) => new Date(b.updatedDate || 0) - new Date(a.updatedDate || 0));
    }
  },
  computed: {
    ...mapGetters(["selectedParticipant", "selectedClient"])
  },
  created() {
    this.fetchData();
  },
  watch: {
    selectedParticipant() {
      this.fetchData();
    }
  }
};
</script>
